exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "h5 .label{margin:0 0 .5rem}", ""]);

